import { useState, useEffect, useCallback } from "react";
import { createAuthAxios, handleApiError } from "../../utils/apiUtils";
import { API_BASE_URL } from "../../config/apiConfig";

/**
 * Hook to fetch trending communities
 * @param {string} time - Time period: 'day' | 'week' | 'month' (default: 'week')
 * @param {number} limit - Number of communities to fetch (default: 5)
 * @returns {Object} - { data, isLoading, error, refetch }
 */
export const useTrendingCommunities = (time = "week", limit = 5) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTrendingCommunities = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);

      const api = createAuthAxios();
      const response = await api.get(
        `${API_BASE_URL}/communities/discover/trending`,
        {
          params: {
            time,
            limit,
          },
        }
      );

      if (response.data.success) {
        setData(response.data.data.communities || []);
      } else {
        throw new Error(
          response.data.message || "Failed to fetch trending communities"
        );
      }
    } catch (err) {
      const errorData = handleApiError(err);
setError(errorData.message || "Failed to load trending communities");
    } finally {
      setIsLoading(false);
    }
  }, [time, limit]);

  useEffect(() => {
    fetchTrendingCommunities();
  }, [fetchTrendingCommunities]);

  return {
    data,
    isLoading,
    error,
    refetch: fetchTrendingCommunities,
  };
};
